import React from 'react';
import styled from 'styled-components';
import { observer } from 'mobx-react-lite';
import Spacer from 'shared/layout/Spacer';
import Separator from 'shared/layout/Separator';

export default observer(({ text }) => (
  <>
    <Spacer left={10} right={10} top={10}>
      <Text>{text}</Text>
    </Spacer>
    <Separator color="purpleTrans10" style={{ margin: '16px 0 12px 0' }} />
  </>
));

const Text = styled.h4`
  color: ${(p) => p.theme.purple90};
  line-height: 16px;
  font-size: 14px;
  letter-spacing: 0.2px;
  text-transform: initial;
  margin: 8px 0;
`;
